import React from 'react';
import { List, Input, InputNumber, Checkbox, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import type { ListingCheckResult, CheckItemUpdate } from '../types';

interface CheckItemRowProps {
    result: ListingCheckResult;
    onUpdate: (itemId: number, updates: CheckItemUpdate) => void;
}

export const CheckItemRow: React.FC<CheckItemRowProps> = ({ result, onUpdate }) => {
    const item = result.item_info;

    return (
        <List.Item
            actions={[
                <Input
                    key="note"
                    placeholder="备注..."
                    size="small"
                    bordered={false}
                    value={result.note || ''}
                    onChange={e => onUpdate(item.id, { note: e.target.value })}
                    style={{ width: 150, textAlign: 'right', color: '#888' }}
                    prefix={<EditOutlined style={{ fontSize: 10 }} />}
                />
            ]}
        >
            <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <div style={{ flex: 1, paddingRight: 16 }}>
                    <Space>
                        {/* Checkbox / compliant status */}
                        <Checkbox
                            checked={!!result.is_compliant}
                            onChange={e => onUpdate(item.id, { is_compliant: e.target.checked })}
                            style={{ transform: 'scale(1.2)', marginRight: 8 }}
                        />

                        <div>
                            <div style={{ fontWeight: 500, fontSize: 15 }}>
                                {item.name}
                            </div>
                            {item.description && (
                                <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>
                                    {item.description}
                                </div>
                            )}
                        </div>
                    </Space>
                </div>

                {/* Value Input (if not bool) */}
                {item.value_type !== 'bool' && (
                    <div style={{ width: 180 }}>
                        {item.value_type === 'number' ? (
                            <InputNumber
                                size="small"
                                placeholder="Number"
                                value={result.value_detected as number}
                                style={{ width: '100%' }}
                                onChange={v => onUpdate(item.id, { value_detected: v as number })}
                            />
                        ) : (
                            <Input
                                size="small"
                                placeholder="输入值..."
                                value={result.value_detected as string}
                                onChange={e => onUpdate(item.id, { value_detected: e.target.value })}
                            />
                        )}
                    </div>
                )}
            </div>
        </List.Item>
    );
};
